module.exports = __webpack_public_path__ + "img/solution_3.9539811a.png";